const mateDetail = () => import("@/pages/mate/mateDetail/mateDetail.vue");
const matePp = () => import("@/pages/mate/matePp/matePp.vue");
const matePurchase = () => import("@/pages/mate/matePurchase/matePurchase.vue");
const mateSupProd = () => import("@/pages/mate/mateSupProd/mateSupProd.vue");
const mateSupplier = () => import("@/pages/mate/mateSupplier/mateSupplier.vue");
const mateWarehouse = () => import("@/pages/mate/mateWarehouse/mateWarehouse.vue");
const mateOut = () => import("@/pages/mate/mateOut/mateOut.vue");
const packagingProd = () => import("@/pages/packagingProd/packagingProd.vue");
const packagingPp = () => import("@/pages/packagingPp/packagingPp.vue");
const logisticsInfo = () => import("@/pages/logisticsInfo/logisticsInfo.vue");
const packagingOut = () => import("@/pages/packagingOut/packagingOut.vue");
const packagingDeatil = () => import("@/pages/packagingDeatil/packagingDeatil.vue");

export default [
  {
    path: "/mate/mateDetail",
    name: "mateDetail",
    component: mateDetail,
    meta: {
      title: "物资台账信息",
      noCache: true,
      affix: true,
      path: ["物资管理", "物资台账信息"]
    }
  },
  {
    path: "/mate/packagingProd",
    name: "packagingProd",
    component: packagingProd,
    meta: {
      title: "包装产品信息",
      noCache: true,
      affix: true,
      path: ["物资管理", "包装产品信息"]
    }
  },
  {
    path: "/mate/packagingPp",
    name: "packagingPp",
    component: packagingPp,
    meta: {
      title: "产品入库信息",
      noCache: true,
      affix: true,
      path: ["物资管理", "产品入库信息"]
    }
  },
  {
    path: "/mate/packagingOut",
    name: "packagingOut",
    component: packagingOut,
    meta: {
      title: "产品出库信息",
      noCache: true,
      affix: true,
      path: ["物资管理", "产品出库信息"]
    }
  },
  {
    path: "/mate/packagingDeatil",
    name: "packagingDeatil",
    component: packagingDeatil,
    meta: {
      title: "产品库存信息",
      noCache: true,
      affix: true,
      path: ["物资管理", "产品库存信息"]
    }
  },
  {
    path: "/mate/logisticsInfo",
    name: "logisticsInfo",
    component: logisticsInfo,
    meta: {
      title: "物流信息",
      noCache: true,
      affix: true,
      path: ["物资管理", "物流信息"]
    }
  },
  {
    path: "/mate/matePp",
    name: "matePp",
    component: matePp,
    meta: {
      title: "入库信息",
      noCache: true,
      affix: true,
      path: ["物资管理", "入库信息"]
    },
  },
  {
    path: "/mate/mateOut",
    name: "mateOut",
    component: mateOut,
    meta: {
      title: "出库信息",
      noCache: true,
      affix: true,
      path: ["物资管理", "出库信息"]
    },
  },
  {
    path: "/mate/matePurchase",
    name: "matePurchase",
    component: matePurchase,
    meta: {
      title: "采购登记信息",
      noCache: true,
      affix: true,
      path: ["物资管理", "采购登记信息"]
    },
  },
  {
    path: "/mate/mateSupProd",
    name: "mateSupProd",
    component: mateSupProd,
    meta: {
      title: "供应商产品信息",
      noCache: true,
      affix: true,
      path: ["物资管理", "供应商产品信息"]
    }
  },
  {
    path: "/mate/mateSupplier",
    name: "mateSupplier",
    component: mateSupplier,
    meta: {
      title: "供应商信息",
      noCache: true,
      affix: true,
      path: ["物资管理", "供应商信息"]
    },
  },
  {
    path: "/mate/mateWarehouse",
    name: "mateWarehouse",
    component: mateWarehouse,
    meta: {
      title: "仓库信息",
      noCache: true,
      affix: true,
      path: ["物资管理", "仓库信息"]
    },
  }
];



// WEBPACK FOOTER //
// ./src/router/mateInfo.js